import intlTelInput from 'intl-tel-input';
import 'intl-tel-input/build/css/intlTelInput.css';
// declare const intlTelInput;

export default class Form {
    fields = [];
    form = null;
    constructor(form) {
        this.form = form;
        this.fields = this.form.querySelectorAll('input, select');
        this.handleEmptryState();
        this.form.querySelectorAll('[type=tel]').forEach(input => {
            this.initTelInput(input);
        })
    }

    initTelInput(input) {
        input = intlTelInput(input, {
            initialCountry: "auto",
            separateDialCode: true,
            hiddenInput: input.getAttribute('data-name') || "",
            geoIpLookup: function(callback) {
                fetch('https://ipinfo.io/json', {
                    cache: 'reload'
                }).then(response => {
                    if ( response.ok ) {
                         return response.json()
                    }
                    throw new Error('Failed: ' + response.status)
                }).then(ipjson => {
                    callback(ipjson.country)
                }).catch(e => {
                    callback('uk')
                })
            },
            utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/16.0.8/js/utils.js"
        });

        // input.telInput.addEventListener("countrychange", (ev) => {
        //     let v = input.getNumber();
        // });

        // input.telInput.addEventListener("keydown", (ev) => {
        //     let v = input.getNumber();
        // });
    }

    handleEmptryState() {
        this.fields.forEach(field => {
            this.setFieldState(field);

            field.addEventListener('keyup', event => {
                this.setFieldState(event.srcElement)
            })
        })
    }

    setFieldState(field = null) {
        if (!field) {
            return;
        }
        if (field.value === '') {
            field.classList.add('--empty-input');
        } else {
            field.classList.remove('--empty-input');
        }
        if (this.form) {
            this.form.classList.add('touched')
        }
    }
}